"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrgApiHttpAttribNameDefault = void 0;
var OrgApiHttpAttribNameDefault;
(function (OrgApiHttpAttribNameDefault) {
    OrgApiHttpAttribNameDefault["RawRequestBody"] = "rawRequestBody";
    OrgApiHttpAttribNameDefault["RequestInfo"] = "requestInfo";
    OrgApiHttpAttribNameDefault["RequestBody"] = "requestBody";
})(OrgApiHttpAttribNameDefault = exports.OrgApiHttpAttribNameDefault || (exports.OrgApiHttpAttribNameDefault = {}));
// inputDataRefs?: Record<string, DataRef>;
//# sourceMappingURL=entrypoint-data.js.map